<div class="editor-container">
  @if (editor(); as ed) {
    <header class="editor-toolbar">
      <select
        class="select select-sm editor-font-select"
        (change)="ed.chain().focus().setFontSize($any($event.target).value).run()">
        <option value="" disabled selected class="hidden">글자 크기</option>
        @for (item of fontSizes; track item.value) {
          <option [value]="item.value" [selected]="ed.isActive('textStyle', { fontSize: item.value })">
            {{ item.name }}
          </option>
        }
      </select>

      <div class="join">
        <button
          type="button"
          data-tip="굵기 적용"
          class="btn btn-square join-item tooltip"
          [class.btn-active]="ed.isActive('bold')"
          (click)="ed.chain().focus().toggleBold().run()">
          <span class="icon-[mdi--format-bold] size-6"></span>
        </button>
        <button
          type="button"
          data-tip="기울이기 적용"
          class="btn btn-square join-item tooltip"
          [class.btn-active]="ed.isActive('italic')"
          (click)="ed.chain().focus().toggleItalic().run()">
          <span class="icon-[mdi--format-italic] size-6"></span>
        </button>
        <button
          type="button"
          data-tip="밑줄 적용"
          class="btn btn-square join-item tooltip"
          [class.btn-active]="ed.isActive('underline')"
          (click)="ed.chain().focus().toggleUnderline().run()">
          <span class="icon-[mdi--format-underline] size-6"></span>
        </button>
        <button
          type="button"
          data-tip="취소선 적용"
          class="btn btn-square join-item tooltip"
          [class.btn-active]="ed.isActive('strike')"
          (click)="ed.chain().focus().toggleStrike().run()">
          <span class="icon-[mdi--format-strikethrough] size-6"></span>
        </button>

        <button
          type="button"
          data-tip="글자색 변경"
          class="gap-0 btn btn-square join-item tooltip"
          (click)="colorInput.click()">
          <input
            #colorInput
            list="colors"
            type="color"
            class="w-0"
            (input)="ed.chain().focus().setColor($event.target.value).run()" />
          <span
            class="icon-[mdi--format-color-text] size-6"
            [style.color]="ed.getAttributes('textStyle')['color'] ?? 'currentColor'"></span>
        </button>

        <button
          type="button"
          data-tip="강조 적용"
          class="gap-0 btn btn-square join-item tooltip"
          (click)="highlight.click()">
          <input
            #highlight
            list="colors"
            type="color"
            class="w-0"
            (input)="ed.chain().focus().setHighlight({ color: $event.target.value }).run()" />
          <span
            class="icon-[mdi--format-color-highlight] size-6"
            [style.color]="ed.getAttributes('highlight')['color'] ?? 'currentColor'"></span>
        </button>
      </div>

      <div class="join">
        <button
          type="button"
          data-tip="왼쪽 정렬"
          class="btn btn-square join-item tooltip"
          [class.btn-active]="ed.isActive({ textAlign: 'left' })"
          (click)="ed.chain().focus().setTextAlign('left').run()">
          <span class="icon-[mdi--format-align-left] size-6"></span>
        </button>
        <button
          type="button"
          data-tip="가운데 정렬"
          class="btn btn-square join-item tooltip"
          [class.btn-active]="ed.isActive({ textAlign: 'center' })"
          (click)="ed.chain().focus().setTextAlign('center').run()">
          <span class="icon-[mdi--format-align-center] size-6"></span>
        </button>
        <button
          type="button"
          data-tip="오른쪽 정렬"
          class="btn btn-square join-item tooltip"
          [class.btn-active]="ed.isActive({ textAlign: 'right' })"
          (click)="ed.chain().focus().setTextAlign('right').run()">
          <span class="icon-[mdi--format-align-right] size-6"></span>
        </button>
        <button
          type="button"
          data-tip="양쪽 정렬"
          class="btn btn-square join-item tooltip"
          [class.btn-active]="ed.isActive({ textAlign: 'justify' })"
          (click)="ed.chain().focus().setTextAlign('justify').run()">
          <span class="icon-[mdi--format-align-justify] size-6"></span>
        </button>
      </div>

      @if (!ed.isActive('table')) {
        <div class="join">
          <button
            type="button"
            data-tip="글머리 기호 목록"
            class="btn btn-square join-item tooltip"
            [class.btn-active]="ed.isActive('bulletList')"
            (click)="ed.chain().focus().toggleBulletList().run()">
            <span class="icon-[mdi--format-list-bulleted] size-6"></span>
          </button>
          <button
            type="button"
            data-tip="번호 매기기 목록"
            class="btn btn-square join-item tooltip"
            [class.btn-active]="ed.isActive('orderedList')"
            (click)="ed.chain().focus().toggleOrderedList().run()">
            <span class="icon-[mdi--format-list-numbered] size-6"></span>
          </button>
        </div>

        <div class="join">
          <button
            type="button"
            data-tip="위첨자"
            class="btn btn-square join-item tooltip"
            [class.btn-active]="ed.isActive('superscript')"
            (click)="ed.chain().focus().toggleSuperscript().run()">
            <span class="icon-[mdi--format-superscript] size-6"></span>
          </button>
          <button
            type="button"
            data-tip="아래첨자"
            class="btn btn-square join-item tooltip"
            [class.btn-active]="ed.isActive('subscript')"
            (click)="ed.chain().focus().toggleSubscript().run()">
            <span class="icon-[mdi--format-subscript] size-6"></span>
          </button>
        </div>
      } @else {
        <div class="join">
          <button
            type="button"
            data-tip="앞에 열 추가"
            class="btn btn-square join-item tooltip"
            (click)="ed.chain().focus().addColumnBefore().run()">
            <span class="icon-[mdi--table-column-plus-before] size-6"></span>
          </button>
          <button
            type="button"
            data-tip="뒤에 열 추가"
            class="btn btn-square join-item tooltip"
            (click)="ed.chain().focus().addColumnAfter().run()">
            <span class="icon-[mdi--table-column-plus-after] size-6"></span>
          </button>

          <button
            type="button"
            data-tip="열 삭제"
            class="btn btn-square join-item tooltip"
            (click)="ed.chain().focus().deleteColumn().run()">
            <span class="icon-[mdi--table-column-remove] size-6"></span>
          </button>

          <button
            type="button"
            data-tip="앞에 행 추가"
            class="btn btn-square join-item tooltip"
            (click)="ed.chain().focus().addRowBefore().run()">
            <span class="icon-[mdi--table-row-plus-before] size-6"></span>
          </button>
          <button
            type="button"
            data-tip="뒤에 행 추가"
            class="btn btn-square join-item tooltip"
            (click)="ed.chain().focus().addRowAfter().run()">
            <span class="icon-[mdi--table-row-plus-after] size-6"></span>
          </button>

          <button
            type="button"
            data-tip="행 삭제"
            class="btn btn-square join-item tooltip"
            (click)="ed.chain().focus().deleteRow().run()">
            <span class="icon-[mdi--table-row-remove] size-6"></span>
          </button>

          <button
            type="button"
            data-tip="셀 병합"
            class="btn btn-square join-item tooltip"
            [disabled]="!ed.can().mergeCells()"
            (click)="ed.chain().focus().mergeCells().run()">
            <span class="icon-[mdi--table-merge-cells] size-6"></span>
          </button>

          <button
            type="button"
            data-tip="셀 분할"
            class="btn btn-square join-item tooltip"
            [disabled]="!ed.can().splitCell()"
            (click)="ed.chain().focus().splitCell().run()">
            <span class="icon-[mdi--table-split-cell] size-6"></span>
          </button>

          <button
            type="button"
            data-tip="표 삭제"
            class="btn btn-square join-item tooltip"
            (click)="ed.chain().focus().deleteTable().run()">
            <span class="icon-[mdi--table-large-remove] size-6"></span>
          </button>
        </div>
      }

      <div class="join">
        <button
          type="button"
          data-tip="링크 삽입"
          popovertarget="link-input"
          style="anchor-name: --link-input-anchor"
          class="btn btn-square join-item tooltip"
          [class.btn-active]="ed.isActive('link')">
          <span class="icon-[mdi--link] size-6"></span>
        </button>

        <div
          popover
          id="link-input"
          #linkInputRef
          class="bg-base-300 rounded-md p-2 w-96"
          style="position-anchor: --link-input-anchor; position-area: bottom span-right">
          <fieldset class="fieldset">
            <legend class="fieldset-legend">링크 추가</legend>
            <div class="flex flex-col gap-2">
              <input #linkTextInput type="text" class="input text-base-content" placeholder="링크 텍스트 (선택사항)" />
              <input
                #urlInput
                type="url"
                class="input text-base-content"
                placeholder="URL을 입력해주세요."
                pattern="^(https?|ftp)://[^\s/$.?#].[^\s]*$" />
              <div class="flex gap-2">
                <button
                  type="button"
                  class="btn btn-primary flex-1"
                  [disabled]="!urlInput.value || !urlInput.validity.valid"
                  (click)="
                    insertLinkWithText(urlInput.value, linkTextInput.value);
                    linkInputRef.hidePopover();
                    clearLinkInputs(urlInput, linkTextInput)
                  ">
                  적용
                </button>
                <button
                  type="button"
                  class="btn btn-ghost"
                  (click)="linkInputRef.hidePopover(); clearLinkInputs(urlInput, linkTextInput)">
                  취소
                </button>
              </div>
            </div>
          </fieldset>
        </div>

        @if (image()) {
          <button
            type="button"
            data-tip="이미지 삽입"
            class="btn btn-square join-item tooltip"
            (click)="selectImage($event)">
            <span class="icon-[mdi--image-plus] size-6"></span>
          </button>
        }

        <button
          type="button"
          data-tip="유튜브"
          class="btn btn-square join-item tooltip"
          [cdkMenuTriggerFor]="youtubeForm">
          <span class="icon-[mdi--youtube] size-6"></span>
        </button>
      </div>

      <div class="join">
        <!-- undo -->
        <button
          type="button"
          data-tip="실행 취소"
          class="btn btn-square join-item tooltip"
          (click)="ed.chain().focus().undo().run()"
          [class.btn-disabled]="!ed.can().undo()">
          <span class="icon-[mdi--undo] size-6"></span>
        </button>
        <!-- redo -->
        <button
          type="button"
          data-tip="다시 실행"
          class="btn btn-square join-item tooltip"
          (click)="ed.chain().focus().redo().run()"
          [class.btn-disabled]="!ed.can().redo()">
          <span class="icon-[mdi--redo] size-6"></span>
        </button>
      </div>
    </header>
  }

  <div
    #editorRef
    class="editor-content"
    tabindex="0"
    (click)="editor()?.commands?.focus()"
    (keydown.enter)="editor()?.commands?.focus()"
    (keydown.space)="editor()?.commands?.focus()"></div>
</div>

<datalist id="colors">
  <option>#f5f5f5</option>
  <option>#d4d4d4</option>
  <option>#737373</option>
  <option>#404040</option>
  <option>#171717</option>

  <option>#fca5a5</option>
  <option>#f87171</option>
  <option>#ef4444</option>
  <option>#dc2626</option>
  <option>#b91c1c</option>

  <option>#fdba74</option>
  <option>#fb923c</option>
  <option>#f97316</option>
  <option>#ea580c</option>
  <option>#c2410c</option>

  <option>#fde047</option>
  <option>#facc15</option>
  <option>#eab308</option>
  <option>#ca8a04</option>
  <option>#a16207</option>

  <option>#86efac</option>
  <option>#4ade80</option>
  <option>#22c55e</option>
  <option>#16a34a</option>
  <option>#15803d</option>

  <option>#7dd3fc</option>
  <option>#38bdf8</option>
  <option>#0ea5e9</option>
  <option>#0284c7</option>
  <option>#0369a1</option>

  <option>#93c5fd</option>
  <option>#60a5fa</option>
  <option>#3b82f6</option>
  <option>#2563eb</option>
  <option>#1d4ed8</option>

  <option>#d8b4fe</option>
  <option>#c084fc</option>
  <option>#a855f7</option>
  <option>#9333ea</option>
  <option>#7e22ce</option>
</datalist>

<ng-template #youtubeForm>
  <div class="flex flex-col gap-2 p-4 bg-white shadow-xl" cdkMenu>
    <h5 class="text-sm font-bold">유튜브 동영상 추가</h5>
    <input class="input" placeholder="유튜브 URL" type="url" #youtubeInputRef />

    @if (isYoutubeUrl(youtubeInputRef.value)) {
      <youtube-player [videoId]="getYouTubeVideoId(youtubeInputRef.value)" [width]="300" [height]="300" />
    }

    <button
      class="btn btn-primary btn-sm"
      [disabled]="!isYoutubeUrl(youtubeInputRef.value)"
      (click)="addYoutube(youtubeInputRef.value)"
      cdkMenuItem>
      추가
    </button>
  </div>
</ng-template>
